import React, { FunctionComponent } from 'react'
import { WidgetBase } from 'Shared/components/builders/WidgetBuilder'
import WidgetContainer from 'Shared/components/builders/WidgetContainer'

import EasySoftwareBenefits, {
  EasySoftwareBenefitsType,
} from '../EasySoftwareBenefits/EasySoftwareBenefits'

export interface WidgetEasySoftwareBenefitsType
  extends WidgetBase,
    EasySoftwareBenefitsType {
  contentType: 'EasySoftwareBenefits'
}

const WidgetEasySoftwareBenefits: FunctionComponent<WidgetEasySoftwareBenefitsType> = (
  props
) => (
  <WidgetContainer
    {...props.puxWidgetProperties}
    {...props.puxWidgetAnimation}
    {...props.metadata}
  >
    <EasySoftwareBenefits
      displayText={props.displayText}
      benefitsList={props.benefitsList}
      benefitsImagePosition={props.benefitsImagePosition}
      benefitsImageSize={props.benefitsImageSize}
      benefitsItemCardCheckbox={props.benefitsItemCardCheckbox}
    />
  </WidgetContainer>
)

export default WidgetEasySoftwareBenefits
